import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

/**
 * @author Renan Salustiano <renan.salustiano@ter.grupomarista.org.br>
 * @param currentPage {number}
 * @param totalPages {number}
 * @param callbackFirstPage {Function}
 * @param callbackNextPage {Function}
 * @param callbackPreviousPage {Function}
 * @param callbackLastPage {Function}
 * @returns {JSX.Element}
 * @constructor
 */
const Pagination = ({
                        currentPage,
                        totalPages,

                        callbackFirstPage,
                        callbackNextPage,
                        callbackPreviousPage,
                        callbackLastPage,
                        genericCallback
                    }) => {

    const nextPage = (e) => {
        e.preventDefault();

        if (currentPage == totalPages) {
            return;
        }

        let _nextPage = currentPage + 1;
        if (callbackNextPage)
            return callbackNextPage(_nextPage)
        genericCallback(_nextPage)
    }

    const previousPage = (e) => {
        e.preventDefault();

        if (currentPage == 1) {
            return;
        }

        let _previousPage = currentPage - 1;
        if (callbackPreviousPage)
            return callbackPreviousPage(_previousPage)
        genericCallback(_previousPage)
    }

    const firstPage = (e) => {
        e.preventDefault();

        if (currentPage == 1) {
            return;
        }

        if (callbackFirstPage)
            return callbackFirstPage(1)
        genericCallback(1)
    }

    const lastPage = (e) => {
        e.preventDefault();

        if (currentPage == totalPages) {
            return;
        }

        if (callbackLastPage)
            return callbackLastPage(totalPages)

        genericCallback(totalPages)
    }

    return totalPages > 1 && (
        <div className={'__pagination'}>
            {currentPage > 1 && (
                <div className='__pagination-button-group'>
                    <button
                        onClick={e => firstPage(e)}
                        className={'__btnChangePage __btnFirstPage'}>
                        <FontAwesomeIcon
                            icon={['fas', 'angle-double-left']}
                        />
                    </button>
                    <button
                        onClick={e => previousPage(e)}
                        className={'__btnChangePage __btnPreviousPage'}>
                        <FontAwesomeIcon
                            icon={['fas', 'angle-left']}
                        />
                    </button>
                </div>
            )}
            <div className={'__pageInfo'}>
                <span className={'__pageNumber'}>{currentPage}</span>
                <span className={'__pageOf'}>de</span>
                <span className={'__pageNumber'}>{totalPages}</span>
            </div>
            {currentPage != totalPages && (
                <div className='__pagination-button-group'>
                    <button
                        onClick={e => nextPage(e)}
                        className={'__btnChangePage __btnNextPage'}>
                        <FontAwesomeIcon
                            icon={['fas', 'angle-right']}
                        />
                    </button>
                    <button
                        onClick={e => lastPage(e)}
                        className={'__btnChangePage __btnLastPage'}>
                        <FontAwesomeIcon
                            icon={['fas', 'angle-double-right']}
                        />
                    </button>
                </div>
            )}
        </div>
    )
}

export default Pagination;
